import { Center, Spinner } from "@chakra-ui/react";
export default function LoadingPage({ minH, spinnerSize = "xl" }) {
  return (
    <Center minH={minH} fontWeight="bold" fontSize={58}>
      <Spinner size={spinnerSize} />
    </Center>
  );
}
